var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"micro-app-box"},[_c('iframe',{ref:"iframeEle",attrs:{"name":"tmsOrder","src":_vm.url,"iframe":"","frameborder":"0"}})])}
var staticRenderFns = []

export { render, staticRenderFns }